import { useEffect, useState } from 'react'

function useCurrentPosition() {
    const [position, setPosition] = useState()

    useEffect(() => {
        if (navigator.geolocation)
            navigator.geolocation.getCurrentPosition(setPosition)
    }, [])

    return (position?.coords.latitude && position?.coords.longitude) ? (
        {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
        }
    ) : null
}

export default useCurrentPosition